// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandlerDiscreteParameter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    shareEntity as shareEntityApi,
    ShareEntityApiParameter,
    shareEntityGenerateFromWebpage,
} from "@insite/client-framework/Services/EmailService";
import { chain, SendDataToApi, ShareEntityParameter } from "@insite/client-framework/Store/CommonHandlers/ShareEntity";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { ShareEntityModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<ShareEntityParameter, ShareEntityApiParameter, ShareEntityModel>;

export const XSendDataToApi: HandlerType = async props => {
    const {
        parameter: { generateAttachmentFromWebpage },
        apiParameter,
    } = props;
    const location = getLocation(props.getState());
    props.apiResult = generateAttachmentFromWebpage
        ? await shareEntityGenerateFromWebpage({
              shareEntityModel: (props.parameter as any).shareEntityModel,
              urlPathToLoadForAttachmentHtml: `${location.pathname + location.search}&disableLazyLoad=true`,
          })
        : await shareEntityApi(apiParameter);
};

replaceInChain(chain, SendDataToApi, XSendDataToApi);
